import React from 'react'
import './ImageStyleSheet.css';

function EducationCLRHS7() {
    window.scrollTo(0,0);
    return (
        <div className="container">
             <img src="/images/clrhs7.jpeg" className='img-view'/>
        </div>
    )
}

export default EducationCLRHS7
